module.exports = __webpack_public_path__ + "img/arc-assistance.408901c5.png";